import { caseConstants } from "@_constants/case.constants";
import { LicenseConstants } from "@_constants/license.constants";
import { caseService } from "@_services/case.service";
import { handleError } from "@_utils/helpers";

export const caseActions = {
  getCase,
  updateCaseOpponentDetails,
  updateCaseLog,
  updateCaseImprint,
  addCaseLog,
  updateCaseFindingImageData,
  updateCaseFindingPrice,
  updateCaseFindingPageLink,
  updateCaseFindingPageScreenshot,
  deleteCaseCallbackRequest,
  updateCaseClaimDetails,
  getCaseChargeDetails,
  updateCaseStateActivate,
  updateCaseStateCancel,
  updateCaseStateReset,
  getCaseWithChargeDetails,
  updateCaseCountry,
  updateCaseBillingCustomFields,
  addCaseAdditionalFees,
  updateCaseLicenseState,
  deleteCaseLicense,
  deleteCaseFinding,
  clearStateMessage,
  addCaseFinding,
  UploadLicense,
  addCaseFlow,
  addCaseTranslation,
  addCaseSendEmail,
  previewCaseLetter,
  getCaseLetterCost,
  emptyCaseLetterCost,
  sendCaseLetter,
  addEmailToLog,
  updateReminder,
  applyCaseTemplate,
  getCaseTemplate,
  toggleAutomation,
  generateInvoice,
  decreaseFailed,
  restoreTriggerEmailFailed,
  addCaseTag,
  deleteCaseTag,
};

function clearStateMessage(stateName) {
  return (dispatch) => {
    dispatch(clear(stateName));
  };

  function clear(stateName) {
    return { type: caseConstants.CASE_CLEAR_STATE_MESSGAE, stateName };
  }
}

function getCase(id, overview) {
  return (dispatch) => {
    dispatch(request());
    caseService.getCase(id).then(
      (caseDetails) => {
        caseDetails.overview = overview;
        dispatch(success(caseDetails));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_GET_REQUEST };
  }
  function success(caseDetails) {
    return { type: caseConstants.CASE_GET_SUCCESS, caseDetails };
  }
  function failure(error) {
    return { type: caseConstants.CASE_GET_FAILURE, error };
  }
}

function getCaseWithChargeDetails(id, overview) {
  return (dispatch) => {
    dispatch(request());
    caseService.getCase(id).then(
      (caseDetails) => {
        caseDetails.overview = overview;
        if (caseDetails.state === "VALID_LICENSE") {
          caseDetails.charge_details = null;
          dispatch(success(caseDetails));
        } else {
          caseService.getCaseChargeDetails(caseDetails.id).then(
            (charge_details) => {
              caseDetails.charge_details = charge_details;
              dispatch(success(caseDetails));
            },
            (error) => {
              dispatch(failure(handleError(error)));
            },
          );
        }
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_GET_REQUEST };
  }
  function success(caseDetails) {
    return { type: caseConstants.CASE_GET_SUCCESS, caseDetails };
  }
  function failure(error) {
    return { type: caseConstants.CASE_GET_FAILURE, error };
  }
}

function updateCaseOpponentDetails(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseOpponentDetails(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_OPPONENT_DETAILS_REQUEST };
  }
  function success(id, data) {
    return {
      type: caseConstants.CASE_UPDATE_OPPONENT_DETAILS_SUCCESS,
      id,
      data,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_OPPONENT_DETAILS_FAILURE, error };
  }
}

function updateCaseLog(id, logId, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseLog(id, logId, data).then(
      (results) => {
        dispatch(success(id, logId, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_LOG_REQUEST };
  }
  function success(id, logId, data) {
    return { type: caseConstants.CASE_UPDATE_LOG_SUCCESS, id, logId, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_LOG_FAILURE, error };
  }
}

function addCaseLog(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseLog(id, data).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_ADD_LOG_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_ADD_LOG_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_ADD_LOG_FAILURE, error };
  }
}

function addCaseSendEmail(id, data, attachments, caseActivityId) {
  if (attachments && attachments.length > 0) {
    data.attachments = attachments;
  }
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseSendEmail(id, data, caseActivityId).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_SEND_EMAIL_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_SEND_EMAIL_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_SEND_EMAIL_FAILURE, error };
  }
}

function previewCaseLetter(caseId, data, templateId) {
  return async (dispatch) => {
    dispatch(request());
    let response;
    try {
      response = await caseService.previewCaseLetter(caseId, data, templateId);
    } catch (error) {
      dispatch(failure(handleError(error.message || error)));
      return;
    }
    const blob = await response.blob().catch((error) => {
      dispatch(failure(handleError(error)));
      return;
    });
    const url = window.URL.createObjectURL(
      new Blob([blob], { type: "application/pdf" }),
    );
    window.open(url, "_blank");
    dispatch(success());
  };
  function request() {
    return { type: caseConstants.CASE_PREVIEW_LETTER_REQUEST };
  }
  function success() {
    return {
      type: caseConstants.CASE_PREVIEW_LETTER_SUCCESS,
    };
  }
  function failure(error) {
    return {
      type: caseConstants.CASE_PREVIEW_LETTER_FAILURE,
      error,
    };
  }
}

function getCaseLetterCost(caseId, data, templateId) {
  return (dispatch) => {
    dispatch(request());
    caseService.getCaseLetterCost(caseId, data, templateId).then(
      (results) => {
        dispatch(success(results.creditCost));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_GET_LETTER_COST_REQUEST };
  }
  function success(data) {
    return { type: caseConstants.CASE_GET_LETTER_COST_SUCCESS, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_GET_LETTER_COST_FAILURE, error };
  }
}

function emptyCaseLetterCost() {
  return (dispatch) => {
    dispatch({
      type: caseConstants.CASE_EMPTY_LETTER_COST,
    });
  };
}

function sendCaseLetter(caseId, data, templateId, oldFailedLetterId) {
  return async (dispatch) => {
    dispatch(request());
    caseService
      .sendCaseLetter(caseId, data, templateId, oldFailedLetterId)
      .then(
        (results) => {
          dispatch(success());
        },
        (error) => {
          dispatch(failure(handleError(error)));
        },
      );
  };
  function request() {
    return { type: caseConstants.CASE_SEND_LETTER_REQUEST };
  }
  function success() {
    return {
      type: caseConstants.CASE_SEND_LETTER_SUCCESS,
    };
  }
  function failure(error) {
    return {
      type: caseConstants.CASE_SEND_LETTER_FAILURE,
      error,
    };
  }
}

function deleteCaseCallbackRequest(id) {
  return (dispatch) => {
    dispatch(request());
    caseService.deleteCaseCallbackRequest(id).then(
      (results) => {
        dispatch(success(id));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_DELETE_CALLBACK_REQUEST_REQUEST };
  }
  function success(id) {
    return { type: caseConstants.CASE_DELETE_CALLBACK_REQUEST_SUCCESS, id };
  }
  function failure(error) {
    return { type: caseConstants.CASE_DELETE_CALLBACK_REQUEST_FAILURE, error };
  }
}

function updateCaseImprint(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseImprint(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_IMPRINT_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_UPDATE_IMPRINT_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_IMPRINT_FAILURE, error };
  }
}

function updateCaseFindingImageData(id, index, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseFindingImageData(id, index, data).then(
      (results) => {
        dispatch(success(id, index, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_FINDING_IMAGE_DATA_REQUEST };
  }
  function success(id, index, data) {
    return {
      type: caseConstants.CASE_UPDATE_FINDING_IMAGE_DATA_SUCCESS,
      id,
      index,
      data,
    };
  }
  function failure(error) {
    return {
      type: caseConstants.CASE_UPDATE_FINDING_IMAGE_DATA_FAILURE,
      error,
    };
  }
}

function getCaseChargeDetails(id) {
  return (dispatch) => {
    dispatch(request());
    caseService.getCaseChargeDetails(id).then(
      (charge_details) => {
        dispatch(success(id, charge_details));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_GET_CHARGE_DETAILS_REQUEST };
  }
  function success(id, charge_details) {
    return {
      type: caseConstants.CASE_GET_CHARGE_DETAILS_SUCCESS,
      id,
      charge_details,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_GET_CHARGE_DETAILS_FAILURE, error };
  }
}

function updateCaseFindingPrice(id, index, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseFindingPrice(id, index, data).then(
      (results) => {
        dispatch(success(id, index, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_FINDING_PRICE_REQUEST };
  }
  function success(id, index, data) {
    return {
      type: caseConstants.CASE_UPDATE_FINDING_PRICE_SUCCESS,
      id,
      index,
      data,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_FINDING_PRICE_FAILURE, error };
  }
}

function updateCaseFindingPageLink(id, index, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseFindingPageLink(id, data).then(
      (results) => {
        dispatch(success(id, index, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_FINDING_PAGE_LINK_REQUEST };
  }
  function success(id, index, data) {
    return {
      type: caseConstants.CASE_UPDATE_FINDING_PAGE_LINK_SUCCESS,
      id,
      index,
      data,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_FINDING_PAGE_LINK_FAILURE, error };
  }
}

function updateCaseFindingPageScreenshot(data, findingId, caseId) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseFindingPageScreenshot(data, findingId, caseId).then(
      (results) => {
        dispatch(success(findingId, caseId, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_FINDING_PAGE_SCREENSHOT_REQUEST };
  }
  function success(findingId, caseId, results) {
    return {
      type: caseConstants.CASE_UPDATE_FINDING_PAGE_SCREENSHOT_SUCCESS,
      findingId,
      caseId,
      results,
    };
  }
  function failure(error) {
    return {
      type: caseConstants.CASE_UPDATE_FINDING_PAGE_SCREENSHOT_FAILURE,
      error,
    };
  }
}

function updateCaseClaimDetails(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseClaimDetails(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_CLAIM_DETAILS_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_UPDATE_CLAIM_DETAILS_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_CLAIM_DETAILS_FAILURE, error };
  }
}

function updateCaseStateActivate(id) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseStateActivate(id).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_STATE_ACTIVATE_REQUEST };
  }
  function success(id, results) {
    return {
      type: caseConstants.CASE_UPDATE_STATE_ACTIVATE_SUCCESS,
      id,
      results,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_STATE_ACTIVATE_FAILURE, error };
  }
}

function updateCaseStateCancel(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseStateCancel(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_STATE_CANCEL_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_UPDATE_STATE_CANCEL_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_STATE_CANCEL_FAILURE, error };
  }
}

function updateCaseStateReset(id) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseStateReset(id).then(
      (results) => {
        dispatch(success(id));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_STATE_RESET_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_UPDATE_STATE_RESET_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_STATE_RESET_FAILURE, error };
  }
}

function updateCaseCountry(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseCountry(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_COUNTRY_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_UPDATE_COUNTRY_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_COUNTRY_FAILURE, error };
  }
}

function updateCaseBillingCustomFields(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseBillingCustomFields(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_BILLING_CUSTOM_FIELDS_REQUEST };
  }
  function success(id, data) {
    return {
      type: caseConstants.CASE_UPDATE_BILLING_CUSTOM_FIELDS_SUCCESS,
      id,
      data,
    };
  }
  function failure(error) {
    return {
      type: caseConstants.CASE_UPDATE_BILLING_CUSTOM_FIELDS_FAILURE,
      error,
    };
  }
}

function addCaseAdditionalFees(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseAdditionalFees(id, data).then(
      (results) => {
        dispatch(success(id, data));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_ADD_ADDITIONAL_FEES_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_ADD_ADDITIONAL_FEES_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_ADD_ADDITIONAL_FEES_FAILURE, error };
  }
}

function UploadLicense(formData, findingId, caseId) {
  return (dispatch) => {
    dispatch(request());
    caseService.uploadLicense(formData, findingId, caseId).then(
      (results) => {
        dispatch(success(findingId, caseId, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: LicenseConstants.UPLOAD_LICENSE_REQUEST };
  }
  function success(findingId, caseId, results) {
    return {
      type: LicenseConstants.UPLOAD_LICENSE_SUCCESS,
      caseId,
      findingId,
      results,
    };
  }
  function failure(error) {
    return { type: LicenseConstants.UPLOAD_LICENSE_FAILURE, error };
  }
}

function updateCaseLicenseState(id, index, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateCaseLicenseState(id, index, data).then(
      (result) => {
        dispatch(success(id, index, data, result));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_LICENSE_STATE_REQUEST };
  }
  function success(id, index, data, result) {
    return {
      type: caseConstants.CASE_UPDATE_LICENSE_STATE_SUCCESS,
      id,
      index,
      data,
      result,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_LICENSE_STATE_FAILURE, error };
  }
}

function deleteCaseLicense(caseId, index, findingId) {
  return (dispatch) => {
    dispatch(request());
    caseService.deleteCaseLicense(caseId, findingId).then(
      (results) => {
        dispatch(success(caseId, index, findingId));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_DELETE_LICENSE_REQUEST };
  }
  function success(caseId, index, findingId) {
    return {
      type: caseConstants.CASE_DELETE_LICENSE_SUCCESS,
      caseId,
      index,
      findingId,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_DELETE_LICENSE_FAILURE, error };
  }
}

function deleteCaseFinding(id, findingId) {
  return (dispatch) => {
    dispatch(request());
    caseService.deleteCaseFinding(id, findingId).then(
      (results) => {
        dispatch(success(id, findingId));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_DELETE_FINDING_REQUEST };
  }
  function success(id, findingId) {
    return { type: caseConstants.CASE_DELETE_FINDING_SUCCESS, id, findingId };
  }
  function failure(error) {
    return { type: caseConstants.CASE_DELETE_FINDING_FAILURE, error };
  }
}

function addCaseFinding(id, data) {
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseFinding(id, data).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_ADD_FINDING_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_ADD_FINDING_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_ADD_FINDING_FAILURE, error };
  }
}

function addCaseFlow(id, flow) {
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseFlow(id, flow).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_ADD_FLOW_REQUEST };
  }
  function success(id, flow) {
    return { type: caseConstants.CASE_ADD_FLOW_SUCCESS, id, flow };
  }
  function failure(error) {
    return { type: caseConstants.CASE_ADD_FLOW_FAILURE, error };
  }
}

function addCaseTranslation(id, translation) {
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseTranslation(id, translation).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_ADD_TRANSLATION_REQUEST };
  }
  function success(id, translation) {
    return {
      type: caseConstants.CASE_ADD_TRANSLATION_SUCCESS,
      id,
      translation,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_ADD_TRANSLATION_FAILURE, error };
  }
}

function addEmailToLog(id, data, caseActivityId) {
  return (dispatch) => {
    dispatch(request());
    caseService.addEmailToLog(id, data, caseActivityId).then(
      (results) => {
        dispatch(success(id, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_SAVE_EMAIL_TO_LOG_REQUEST };
  }
  function success(id, data) {
    return { type: caseConstants.CASE_SAVE_EMAIL_TO_LOG_SUCCESS, id, data };
  }
  function failure(error) {
    return { type: caseConstants.CASE_SAVE_EMAIL_TO_LOG_FAILURE, error };
  }
}

function updateReminder(id, deadline) {
  return (dispatch) => {
    dispatch(request());
    caseService.updateReminder(id, deadline).then(
      (results) => {
        dispatch(success(id, deadline, results));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_UPDATE_DEADLINE_REQUEST };
  }

  function success(id, deadline, results) {
    return {
      type: caseConstants.CASE_UPDATE_DEADLINE_SUCCESS,
      id,
      deadline,
      results,
    };
  }

  function failure(error) {
    return { type: caseConstants.CASE_UPDATE_DEADLINE_FAILURE, error };
  }
}

function applyCaseTemplate(id, template) {
  return (dispatch) => {
    dispatch(request());
    caseService.applyCaseTemplate(id, template.id).then(
      (resp) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_APPLY_TEMPLATE_REQUEST };
  }
  function success(resp) {
    return { type: caseConstants.CASE_APPLY_TEMPLATE_SUCCESS, resp };
  }
  function failure(error) {
    return { type: caseConstants.CASE_APPLY_TEMPLATE_FAILURE, error };
  }
}

function getCaseTemplate(caseId, templateId) {
  return (dispatch) => {
    dispatch(request());
    caseService.getCaseTemplate(caseId, templateId).then(
      (template) => {
        dispatch(success(template));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_GET_TEMPLATE_REQUEST };
  }
  function success(template) {
    return { type: caseConstants.CASE_GET_TEMPLATE_SUCCESS, template };
  }
  function failure(error) {
    return { type: caseConstants.CASE_GET_TEMPLATE_FAILURE, error };
  }
}

function toggleAutomation(caseId, state) {
  return (dispatch) => {
    dispatch(request());
    caseService.toggleAutomation(caseId, state).then(
      (results) => {
        dispatch(success(caseId, state));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_TOGGLE_AUTOMATION_REQUEST };
  }
  function success(id, state) {
    return { type: caseConstants.CASE_TOGGLE_AUTOMATION_SUCCESS, id, state };
  }
  function failure(error) {
    return { type: caseConstants.CASE_TOGGLE_AUTOMATION_FAILURE, error };
  }
}

function generateInvoice(caseId, address) {
  return (dispatch) => {
    dispatch(request());
    caseService.generateInvoice(caseId, address).then(
      async (response) => {
        dispatch(success(caseId, response));
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_GENERATE_INVOICE_REQUEST };
  }
  function success(caseId, response) {
    return {
      type: caseConstants.CASE_GENERATE_INVOICE_SUCCESS,
      caseId,
      response,
    };
  }
  function failure(error) {
    return { type: caseConstants.CASE_GENERATE_INVOICE_FAILURE, error };
  }
}

function decreaseFailed(caseId, typeFailedEmails) {
  return (dispatch) => {
    dispatch(toggleFail(caseId, typeFailedEmails));
  };

  function toggleFail(caseId, typeFailedEmails) {
    return {
      type: caseConstants.CASE_DECREASE_FAILED,
      caseId,
      typeFailedEmails,
    };
  }
}

function restoreTriggerEmailFailed() {
  return (dispatch) => {
    dispatch({ type: caseConstants.CASE_RESTORE_TRIGGER_SENDING_EMAIL_FAILED });
  };
}

function addCaseTag(caseId, tag) {
  return (dispatch) => {
    dispatch(request());
    caseService.addCaseTag(caseId, tag).then(
      async (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_ADD_TAG_REQUEST };
  }
  function success() {
    return { type: caseConstants.CASE_ADD_TAG_SUCCESS };
  }
  function failure(error) {
    return { type: caseConstants.CASE_ADD_TAG_FAILURE, error };
  }
}

function deleteCaseTag(caseId, tag) {
  return (dispatch) => {
    dispatch(request());
    caseService.deleteCaseTag(caseId, tag).then(
      async (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(handleError(error)));
      },
    );
  };

  function request() {
    return { type: caseConstants.CASE_DELETE_TAG_REQUEST };
  }
  function success() {
    return { type: caseConstants.CASE_DELETE_TAG_SUCCESS };
  }
  function failure(error) {
    return { type: caseConstants.CASE_DELETE_TAG_FAILURE, error };
  }
}
